import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { readMetaTag } from '@rsos/base-utils/metaTags';
import { UNITE_EVENT_PANE } from '@rsos/capstone/src/constants/capabilities';
import { UNITE_EVENT_PANE_PERMISSION } from '@rsos/capstone/src/constants/permissionNames';
import { CENTRAL_STATION } from '@rsos/constants/appNames';
import { DARK_THEME, DARKER_THEME, LIGHT_THEME } from '@rsos/theme/constants';
import { APP_NAME } from '@rsos/utils/metaTags';
import useHasCapability from './useHasCapability';
import useHasPermission from './useHasPermission';

const isCSP = readMetaTag(APP_NAME) === CENTRAL_STATION;

/**
 * Get the selected theme name.
 * @returns String
 */
const useSelectedTheme = () => {
  const hasUniteEventPaneCapabilities = useHasCapability(UNITE_EVENT_PANE);

  const hasUniteEventPanePermission = useHasPermission(
    UNITE_EVENT_PANE_PERMISSION,
  );

  const isUniteEventPaneEnabled = Boolean(
    hasUniteEventPaneCapabilities?.hasCapability &&
      hasUniteEventPanePermission?.hasPermission,
  );

  const themeName = useSelector(state => {
    const currentRole = state.sinatra.user.currentRole;

    const attributes = state.sinatra.user.profile?.attributes;

    const applicationName = currentRole?.application;

    return attributes?.[applicationName]?.theme_settings?.theme || LIGHT_THEME;
  });

  return useMemo(() => {
    if (themeName === LIGHT_THEME) {
      return LIGHT_THEME;
    }

    if (isCSP) {
      return DARKER_THEME;
    }

    return isUniteEventPaneEnabled ? DARKER_THEME : DARK_THEME;
  }, [isUniteEventPaneEnabled, themeName]);
};

export default useSelectedTheme;
